export const GOOGLE_PLUS_IMAGE = require("../assets/images/googles.png");
export const OFFICE_365_IMAGE = require("../assets/images/office-365.png");
export const LOGO_IMAGE = require("../assets/images/logo.png");
export const LOGO_SM_IMAGE = require("../assets/images/logo-sm.png");
export const VAULT_LOGO_IMAGE = require("../assets/images/vaultLogo.png");
export const login_Right_img = require("../assets/images/login-right-img.png");
export const signin_Right_img = require("../assets/images/sign-right-img.png");
export const Right_Bg_Img = require("../assets/images/right-bg.png");
export const OPPS_IMG = require("../assets/images/opps.png");
export const WelCOME_IMG = require("../assets/images/welcome.png");
export const ALMOST_IMG = require("../assets/images/almost.png");
export const VERIFY_IMG = require("../assets/images/verify.png");
export const LOGIN_IMAGE = require("../assets/images/xion-signup-logo.png");
export const UPLOAD_IMAGE = require("../assets/images/upload-icon.png");
export const ARROW_IMAGE = require("../assets/images/arroworder.png");
export const ADD_CIRCLE = require("../assets/images/add_circle.png");
export const EDIT_CIRCLE = require("../assets/images/edit_icon.png");
export const REMOVE_CIRCLE = require("../assets/images/remove_circle.png");
export const UPLOAD_CIRCLE = require("../assets/images/upload_circle.png");
export const MOVE_CIRCLE = require("../assets/images/move_circle.png");
export const DOCUMENT_PROCESSING = require("../assets/images/document-process.gif");
export const DOCUMENT_PROCESSED = require("../assets/images/document-processed.gif");
export const DOCUMENT_UPLOADED = require("../assets/images/document-uploaded.gif");
export const XERO_LOGO = require("../assets/images/xero.png");
export const SLIDER_IMG1 = require("../assets/images/slider1.png");
export const SLIDER_IMG2 = require("../assets/images/slider2.png");
export const SLIDER_IMG3 = require("../assets/images/slider3.png");
export const SLIDER_IMG4 = require("../assets/images/slider4.png");
export const SLIDER_IMG5 = require("../assets/images/slider5.png");
export const QUICKBOOKS_LOGO = require("../assets/images/quickbooks.jpg");
// export const QUICKBOOKS_CIRCLE_LOGO = require("../assets/images/quickbookscircle.png");
export const QUICKBOOKS_CIRCLE_LOGO = require("../assets/images/quick.png");
export const NO_INTEGRATION = require("../assets/images/no-integration.png");
export const ANDROID_QR = require("../assets/images/android-qr.png");
// export const TEMPLATE_FILE = require("../assets/template.csv");
export const COPY_IMG = require("../assets/images/copy-icon.png");
export const BILLING_IMG1 = require("../assets/images/billing1.jpg");
export const BILLING_IMG2 = require("../assets/images/billing2.jpg");
